import "@ingka/svg-icon/style.scss";
import STHGridCard from "./STHGridVard/STHGridCard";
import "./ServiceToHelp.scss";
import { useTranslate } from "../../translate";
import { useSelector } from "react-redux";
import { useState } from "react";
import Button from "@ingka/button";
import Modal, { Prompt, ModalFooter, ModalBody } from "@ingka/modal";
import Constants from "../../Constants";
import "@ingka/svg-icon/style.scss";
import "@ingka/button/style.scss";
import "@ingka/modal/style.scss";
import "@ingka/focus/style.scss";

const ServiceToHelp = ({ onClick, mode }) => {
  const i18n = useTranslate();
  const { t, isRtl, getCurrentLanguageCode } = i18n;

  const [barcodeImg, setBarcodeImage] = useState("");
  const [barcodeModalVisible, setBarcodeModalVisible] = useState(false);
  const closeBarcodeModal = () => setBarcodeModalVisible(false);

  const currentLanguageCode = getCurrentLanguageCode();

  const helpConfig = useSelector(({ uiConfig }) => uiConfig?.config ?? []);
  const miniSecConfigs =
    helpConfig &&
    helpConfig.filter((item) => item.type === "mini" && item?.show);

  const handleItemClick = (item) => {
    if (mode === Constants.modeType.kiosk) {
      if (item?.[currentLanguageCode]?.barcode) {
        setBarcodeImage(item?.[currentLanguageCode]?.barcode);
        setBarcodeModalVisible(true);
      }
    } else {
      if (item?.[currentLanguageCode]?.linkUrl) {
        window.location.href = item?.[currentLanguageCode]?.linkUrl;
      }
    }
  };

  return (
    <>
      {Array.isArray(miniSecConfigs) && (
        <>
          <div className="mini-items">
            {miniSecConfigs.map((miniSecConfig, index) => {
              if (
                (mode === Constants.modeType.kiosk &&
                  !miniSecConfig?.showInKiosk) ||
                (mode !== Constants.modeType.kiosk && !miniSecConfig?.showInWeb)
              ) {
                return <></>;
              }

              return (
                <div className="mini-item" key={index}>
                  <div className="home-container--title">
                    {miniSecConfig?.[currentLanguageCode]?.title}
                  </div>
                  <div className="service-to-help-container">
                    <div className="grid-container-service">
                      {miniSecConfig?.menuItems &&
                        miniSecConfig?.menuItems.map((item, kindex) => {
                          if (!item?.visible) return <></>;

                          if (
                            (mode === Constants.modeType.kiosk &&
                              !item?.showInKiosk) ||
                            (mode !== Constants.modeType.kiosk &&
                              !item?.showInWeb)
                          ) {
                            return <></>;
                          }

                          return (
                            <div
                              className="grid-item"
                              dir={isRtl() ? "rtl" : "ltr"}
                              key={kindex}
                            >
                              <STHGridCard
                                title={item?.[currentLanguageCode]?.title}
                                icon={item?.icon?.data?.full_url}
                                description={item?.[currentLanguageCode]?.desc}
                                onClick={() => handleItemClick(item)}
                                mode={mode}
                                handIcon={item?.click_me_icon?.data?.full_url}
                                handIconShowInWeb={
                                  item?.click_me_icon_show_in_web
                                }
                                handIconShowInKiosk={
                                  item?.click_me_icon_show_in_kiosk
                                }
                              />
                            </div>
                          );
                        })}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
          <Modal
            visible={barcodeModalVisible}
            escapable={false}
            handleCloseBtn={closeBarcodeModal}
            onModalOpened={() => {}}
          >
            <Prompt
              footer={
                <ModalFooter>
                  <Button
                    className="check-balance-btn"
                    type="emphasised"
                    text={t("home.close.title")}
                    onClick={closeBarcodeModal}
                  />
                </ModalFooter>
              }
              body={<ModalBody></ModalBody>}
            >
              <img
                alt="barcode img"
                src={barcodeImg}
                className="service-to-help-container__barcode"
              />
            </Prompt>
          </Modal>
        </>
      )}
    </>
  );
};

export default ServiceToHelp;
